export default "__VITE_ASSET__7f41d888__"